import type { ReactNode } from "react";

/**
 * Shared loading / error / empty scaffolding for the data-backed views. These
 * mirror the inline states ClientsPage authored, factored out so the four new
 * views render identical affordances without copy-paste drift.
 */

export function LoadingPanel({ label }: { label: string }) {
  return (
    <div className="flex justify-center px-6 py-12">
      <div className="text-center">
        <div className="mx-auto mt-0 mb-2.5 size-[30px] animate-[spin_0.8s_linear_infinite] rounded-full border-2 border-[color-mix(in_oklch,var(--pro)_25%,transparent)] border-t-pro" />
        <p className="view-sub">{label}</p>
      </div>
    </div>
  );
}

export function ErrorPanel({
  title,
  message,
  onRetry,
}: {
  title: string;
  message: string;
  onRetry: () => void;
}) {
  return (
    <div className="max-w-[560px] px-6 py-12">
      <h2 className="view-h1 text-xl">
        {title}
      </h2>
      <p className="view-sub mt-1.5">
        {message}
      </p>
      <button
        type="button"
        className="ra-view mt-3.5"
       
        onClick={onRetry}
      >
        Try again
      </button>
    </div>
  );
}

export function EmptyPanel({
  icon,
  title,
  description,
  action,
}: {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
}) {
  return (
    <div className="panel-empty">
      {icon}
      <h2 className="view-h1 text-lg">
        {title}
      </h2>
      {description && (
        <p className="view-sub mx-auto mt-1.5 mb-0 max-w-[420px]">
          {description}
        </p>
      )}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
